import { Mail, Phone } from 'lucide-react';
import "../../../../assets/css/components/customer/home/topbar/Topbar.css"
const Topbar = () => {
  return (
    <>
 {/* Top Bar */}
 
      <div className="top-bar">
        <div className="topbar-container">
          <div className="topbar-left">
            {/* <a href="tel:+923298003382" className="topbar-link">
              <Phone size={16} />
              <span>+923298003382</span>
            </a> */}
            <a href="mailto:Customercare@picks4tips.com" className="topbar-link">
              <Mail size={16} />
              <span>Customercare@picks4tips.com</span>
            </a>
          </div>
        </div>
      </div>
      </>
  );
};

export default Topbar;